/**
 * Created by XuDL(Wisea) on 2019-2-22 15:20:20
 */
import $ from "jquery";
window.jQuery=$
;
(function (window, $, undefined) {

  "use strict";

  $(window).data("ds-DataDict", {
    "DataDict": {
      "zj_start_date": [{
        "id": "980",
        "label": "一周",
        "value": "0"
      }, {
        "id": "990",
        "label": "一个月",
        "value": "1"
      }, {
        "id": "1000",
        "label": "半年",
        "value": "2"
      }, {
        "id": "1010",
        "label": "一年",
        "value": "3"
      }, {
        "id": "1020",
        "label": "一年以上",
        "value": "4"
      }],
      "blacklist_type": [{
        "id": "10000",
        "label": "已封停",
        "value": "0"
      }, {
        "id": "10100",
        "label": "已解封",
        "value": "1"
      }],
      "notice_state": [{
        "id": "880",
        "label": "待发布",
        "value": "0"
      }, {
        "id": "890",
        "label": "已发布",
        "value": "1"
      }],
      "purch_type": [{
        "id": "210",
        "label": "招标采购",
        "value": "0"
      }, {
        "id": "220",
        "label": "谈判采购",
        "value": "1"
      }, {
        "id": "230",
        "label": "直接挂网采购",
        "value": "2"
      }, {
        "id": "240",
        "label": "定点生产",
        "value": "3"
      }, {
        "id": "250",
        "label": "其他",
        "value": "4"
      }],
      "short_type": [{
        "id": "260",
        "label": "断货",
        "value": "0"
      }, {
        "id": "270",
        "label": "供应量不足",
        "value": "1"
      }, {
        "id": "280",
        "label": "供应量不及时",
        "value": "2"
      }],
      "use_replace_drug_type": [{
        "id": "380",
        "label": "无替代",
        "value": "0"
      }, {
        "id": "390",
        "label": "相同通用名药品替代",
        "value": "1"
      }, {
        "id": "400",
        "label": "功效相同或相近的不同通用名药品替代",
        "value": "2"
      }],
      "level_type": [{
        "id": "10",
        "label": "国家级",
        "value": "0"
      }, {
        "id": "20",
        "label": "省级主管部门",
        "value": "1"
      }, {
        "id": "30",
        "label": "市级主管部门",
        "value": "2"
      }, {
        "id": "40",
        "label": "区县级主管部门",
        "value": "3"
      }],
      "curr_disp_status": [{
        "id": "410",
        "label": "县级处置中",
        "value": "0"
      }, {
        "id": "420",
        "label": "县级已解决",
        "value": "1"
      }, {
        "id": "430",
        "label": "市级处置中",
        "value": "2"
      }, {
        "id": "440",
        "label": "市级已解决",
        "value": "3"
      }, {
        "id": "450",
        "label": "省级处置中",
        "value": "4"
      }, {
        "id": "460",
        "label": "省级已解决",
        "value": "5"
      }, {
        "id": "470",
        "label": "已上报国家级",
        "value": "6"
      }, {
        "id": "475",
        "label": "县级已驳回",
        "value": "7"
      }, {
        "id": "476",
        "label": "市级已驳回",
        "value": "8"
      }, {
        "id": "478",
        "label": "省级已驳回",
        "value": "9"
      }, {
        "id": "477",
        "label": "国家已处置",
        "value": "10"
      }, {
        "id": "479",
        "label": "国家已驳回",
        "value": "11"
      }],
      "default_entry_mode_type": [{
        "id": "90",
        "label": "表单式录入",
        "value": "0"
      }, {
        "id": "100",
        "label": "卡片式录入",
        "value": "1"
      }],
      "short_age_flag": [{
        "id": "190",
        "label": "是",
        "value": "0"
      }, {
        "id": "200",
        "label": "否",
        "value": "1"
      }],
      "user_type": [{
        "id": "70",
        "label": "医疗机构",
        "value": "0"
      }, {
        "id": "80",
        "label": "主管部门",
        "value": "1"
      }],
      "drug_dq_type": [{
        "id": "650",
        "label": "基本药物",
        "value": "1"
      }, {
        "id": "660",
        "label": "抗癌药（17种）",
        "value": "2"
      }, {
        "id": "670",
        "label": "易短缺药（104种）",
        "value": "3"
      }, {
        "id": "680",
        "label": "“4+7”（25种）",
        "value": "4"
      }, {
        "id": "690",
        "label": "价格涨幅较大品种（78种）",
        "value": "5"
      }, {
        "id": "700",
        "label": "低价药",
        "value": "6"
      }, {
        "id": "710",
        "label": "儿童药",
        "value": "7"
      }, {
        "id": "720",
        "label": "国家医保内药品",
        "value": "8"
      }, {
        "id": "725",
        "label": "省级储备药",
        "value": "9"
      }],
      "drug_type": [{
        "id": "480",
        "label": "基本药物",
        "value": "0"
      }, {
        "id": "490",
        "label": "国家级医保目录内药物",
        "value": "1"
      }, {
        "id": "500",
        "label": "省级医保目录内药物",
        "value": "2"
      }, {
        "id": "510",
        "label": "妇科用药",
        "value": "3"
      }, {
        "id": "520",
        "label": "儿童用药",
        "value": "4"
      }, {
        "id": "530",
        "label": "急抢救用药",
        "value": "5"
      }, {
        "id": "540",
        "label": "毒麻精放类用药",
        "value": "6"
      }],
      "rank": [{
        "id": "770",
        "label": "甲等",
        "value": "0"
      }, {
        "id": "780",
        "label": "乙等",
        "value": "1"
      }, {
        "id": "790",
        "label": "丙等",
        "value": "2"
      }, {
        "id": "800",
        "label": "未定等",
        "value": "3"
      }],
      "effect_statue": [{
        "id": "810",
        "label": "已生效",
        "value": "0"
      }, {
        "id": "820",
        "label": "未生效",
        "value": "1"
      }],
      "file_state": [{
        "id": "860",
        "label": "未下载",
        "value": "0"
      }, {
        "id": "870",
        "label": "已下载",
        "value": "1"
      }],
      "nation_prov_flag": [{
        "id": "550",
        "label": "国家",
        "value": "0"
      }, {
        "id": "560",
        "label": "省份",
        "value": "1"
      }],
      "del_flag": [{
        "id": "50",
        "label": "正常",
        "value": "0"
      }, {
        "id": "60",
        "label": "已删除",
        "value": "1"
      }],
      "acct_num_state": [{
        "id": "110",
        "label": "停用",
        "value": "0"
      }, {
        "id": "120",
        "label": "启用",
        "value": "1"
      }],
      "level": [{
        "id": "730",
        "label": "一级",
        "value": "0"
      }, {
        "id": "740",
        "label": "二级",
        "value": "1"
      }, {
        "id": "750",
        "label": "三级",
        "value": "2"
      }, {
        "id": "760",
        "label": "未定级",
        "value": "3"
      }],
      "report_type": [{
        "id": "130",
        "label": "待填报",
        "value": "0"
      }, {
        "id": "140",
        "label": "待上报",
        "value": "1"
      }, {
        "id": "150",
        "label": "未上报",
        "value": "2"
      }, {
        "id": "160",
        "label": "已上报",
        "value": "3"
      }],
      "relea_state": [{
        "id": "570",
        "label": "待发布",
        "value": "0"
      }, {
        "id": "580",
        "label": "已发布",
        "value": "1"
      }],
      "kcgl_type": [{
        "id": "830",
        "label": "1至3个月",
        "value": "0"
      }, {
        "id": "840",
        "label": "半年",
        "value": "1"
      }, {
        "id": "850",
        "label": "一年及以上",
        "value": "2"
      }, {
        "id": "855",
        "label": "不能连续供应",
        "value": "3"
      }],
      "short_reason_type": [
      /*2023-8-14 以前的数据，不确定数据来源
      {
        "id": "290",
        "label": "流标废标，无企业供货",
        "value": "0"
      }, {
        "id": "300",
        "label": "原料短缺，产能不足",
        "value": "1"
      }, {
        "id": "310",
        "label": "原料垄断，产能不足",
        "value": "2"
      }, {
        "id": "320",
        "label": "企业生产线改造，企业产能不足",
        "value": "3"
      }, {
        "id": "330",
        "label": "交易价格低，企业不愿生产",
        "value": "4"
      }, {
        "id": "340",
        "label": "限价交易，企业不愿供应",
        "value": "5"
      }, {
        "id": "350",
        "label": "地域偏远，不愿供应",
        "value": "6"
      }, {
        "id": "360",
        "label": "临床用量小，企业不愿供应",
        "value": "7"
      }, {
        "id": "365",
        "label": "价格上涨",
        "value": "8"
      }, {
        "id": "370",
        "label": "其他原因",
        "value": "9"
      },{
        "id": "380",
        "label": "价格低,不愿供应",
        "value": "10"
      },{
        "id": "390",
        "label": "采购量少,不愿供应",
        "value": "11"
      },{
        "id": "400",
        "label": "停产减产,产量不足",
        "value": "12"
      },{
        "id": "410",
        "label": "采购量少，企业不愿供应",
        "value": "13"
      },{
        "id": "420",
        "label": "价格过低，企业不愿供应",
        "value": "14"
      },{
        "id": "430",
        "label": "地域偏远，企业不愿供应",
        "value": "15"
      },{
        "id": "440",
        "label": "产量不足，配送企业无货",
        "value": "16"
      }*/
      //2023-8-14 之后的数据
      {
        "id": "290",
        "label": "流标废标，无企业供货",
        "value": "0"
      }, {
        "id": "300",
        "label": "原料短缺，产能不足",
        "value": "1"
      }, {
        "id": "310",
        "label": "原料垄断，产能不足",
        "value": "2"
      }, {
        "id": "320",
        "label": "企业生产线改造，企业产能不足",
        "value": "3"
      }, {
        "id": "330",
        "label": "交易价格低，企业不愿生产",
        "value": "4"
      }, {
        "id": "340",
        "label": "限价交易，企业不愿供应",
        "value": "5"
      }, {
        "id": "350",
        "label": "地域偏远，不愿供应",
        "value": "6"
      }, {
        "id": "360",
        "label": "临床用量小，企业不愿供应",
        "value": "7"
      }, {
        "id": "365",
        "label": "价格上涨",
        "value": "8"
      }, {
        "id": "370",
        "label": "其他原因",
        "value": "9"
      },{
        "id": "380",
        "label": "价格低,不愿供应",
        "value": "10"
      },{
        "id": "390",
        "label": "采购量少,不愿供应",
        "value": "11"
      },{
        "id": "400",
        "label": "停产减产,产量不足",
        "value": "12"
      },{
        "id": "991",
        "label": "采购平台无企业供货",
        "value": "13"
      },{
        "id": "992",
        "label": "货源紧张无法足量供应",
        "value": "14"
      },{
        "id": "993",
        "label": "原料短缺无法供应",
        "value": "15"
      },{
        "id": "994",
        "label": "产量不足，配送企业无货",
        "value": "16"
      },{
        "id": "995",
        "label": "价格上涨，不按中标价供货",
        "value": "17"
      }

    ],
      "rece_memb_type": [{
        "id": "920",
        "label": "全部用户",
        "value": "0"
      }, {
        "id": "930",
        "label": "省级管理部门用户",
        "value": "1"
      }, {
        "id": "940",
        "label": "全部管理部门用户",
        "value": "2"
      }, {
        "id": "950",
        "label": "医疗机构用户",
        "value": "3"
      }],
      "read_state": [{
        "id": "900",
        "label": "未查看",
        "value": "0"
      }, {
        "id": "910",
        "label": "已查看",
        "value": "1"
      }],
      "sms_template_type": [{
        "id": "e6d0faa6b1584486884ad915239a59e9",
        "label": "smsCode",
        "value": "【短缺药品信息直报平台】{0}（验证码，{1}分钟内有效）为了您的帐户安全请勿告知他人，如非本人操作请忽略。"
      }],
      "entp_type": [{
        "id": "590",
        "label": "生产企业",
        "value": "0"
      }, {
        "id": "600",
        "label": "流通企业",
        "value": "1"
      }],
      "drug_curr_disp_status": [{
        "id": "610",
        "label": "本级已解决",
        "value": "0"
      }, {
        "id": "620",
        "label": "未处置报送上级",
        "value": "1"
      }, {
        "id": "630",
        "label": "驳回此药品",
        "value": "2"
      }, {
        "id": "640",
        "label": "未处置",
        "value": "3"
      }],
      "key_moni_type": [{
        "id": "170",
        "label": "是",
        "value": "0"
      }, {
        "id": "180",
        "label": "否",
        "value": "1"
      }],
      "notice_type": [{
        "id": "171",
        "label": "通知公告",
        "value": "0"
      }, {
        "id": "172",
        "label": "监测报告",
        "value": "1"
      }, {
        "id": "173",
        "label": "药品信息",
        "value": "3"
      }],
      "is_respond": [{
        "id": "181",
        "label": "是",
        "value": "0"
      }, {
        "id": "182",
        "label": "否",
        "value": "1"
      }],
    }
  });

})(window, window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./static/js/DataDict.js
// module id = null
// module chunks = 